import { useSyncExternalStore } from 'react';
import { useInstantSearch } from 'react-instantsearch';

import { Filters } from '@sorare/core/src/components/search/Filter';
import { useConfigContext } from '@sorare/core/src/contexts/config';
import { FILTERS } from '@sorare/core/src/lib/filters';

const VALID_UNTIL_ATTRIBUTE = 'playing_status_odds.valid_until';

const REFRESH_INTERVAL = 60_000;

const subscribeToKickoffCutoff = (onChange: () => void) => {
  const id = setInterval(onChange, REFRESH_INTERVAL);
  return () => clearInterval(id);
};

// Quantised so consecutive reads within the same minute return an identical snapshot, which is what
// `useSyncExternalStore` requires and what keeps the filter string — and so the Algolia query — stable.
const getKickoffCutoff = () =>
  Math.floor(Date.now() / REFRESH_INTERVAL) * (REFRESH_INTERVAL / 1000);

// The indexed prediction keeps its last written value until something rewrites it, so a request that
// ranks or filters on it must also exclude the records whose game has kicked off. The GraphQL card
// search gets this from the backend; talking to Algolia directly, nothing injects it.
export const StartingPredictionValidity = () => {
  const { algoliaCardIndexes } = useConfigContext();
  const { indexUiState } = useInstantSearch();
  const cutoff = useSyncExternalStore(
    subscribeToKickoffCutoff,
    getKickoffCutoff
  );

  const sortedByStartingPrediction =
    indexUiState.sortBy ===
    algoliaCardIndexes['Cards On Sale Starting Prediction'];
  const refinedOnStartingPrediction =
    !!indexUiState.range?.[FILTERS.startingPrediction.attribute];

  if (!sortedByStartingPrediction && !refinedOnStartingPrediction) return null;

  return <Filters filters={[`${VALID_UNTIL_ATTRIBUTE} > ${cutoff}`]} />;
};
